import styled from 'styled-components';

import { IconButton } from '@xemplo/icon-button';
import { Colour, Shadow } from '@xemplo/style-constants';
import { zIndex } from '@xemplo/zindex';

import { DrawerPosition } from './drawer.types';

export { DrawerHeaderWrapper } from './header/drawer-header.styles';

/** Extra off-screen distance so the drawer's box shadow never bleeds into the viewport while closed */
const SHADOW_CLEARANCE_PX = 24;

export const DrawerWrapper = styled.aside`
  --drawer-scroll-shadown-bottom: 0;
  --drawer-width: 488px;
  --drawer-top-offset: 0;
  position: fixed;
  top: var(--drawer-top-offset);
  bottom: 0;
  width: var(--drawer-width, 488px);
  ${Shadow.Medium2};
  background: ${Colour.Clarity.Background.Surface};
  border-left: 1px solid ${Colour.Clarity.Grey.Soft};
  z-index: ${zIndex.Modal};
  visibility: hidden;

  transition:
    transform 0.3s ease-out,
    visibility 0s linear 0.3s;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &[data-position=${DrawerPosition.Right}] {
    right: 0;
    transform: translateX(calc(100% + ${SHADOW_CLEARANCE_PX}px));
  }

  &[data-position=${DrawerPosition.Left}] {
    left: 0;
    transform: translateX(calc(-100% - ${SHADOW_CLEARANCE_PX}px));
  }

  &[data-open='true'] {
    transform: translateX(0);
    visibility: visible;
    transition: transform 0.3s ease-out;
  }
`;

export const DrawerContentWrapper = styled.div<{ $offset?: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: ${zIndex.ModalCloseButton};
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(17, 19, 34, 0.6);
  z-index: ${zIndex.ModalOverlay};
`;
